import React, { useCallback, useState, useMemo, useEffect, useRef } from 'react';
import styles from './Actions.module.scss';
import './actions.css';
import Button from '../../../../components/button/Button';
import { useNextContent } from '../../useNextContent';
import {
  ContentType,
  useCancelFeedbackFormMutation,
} from '@api/graphql-codegen';
import InfoCircleIcon from '@src/assets/icons/infocircle.svg?react';
import TicketIcon from 'src/assets/icons/ticket.svg?react';
import WarningIcon from 'src/assets/icons/red-warning.svg?react';
import OutlineIcon from 'src/assets/icons/outline.svg?react';
import CloseIcon from 'src/assets/icons/close.svg?react';

import { create, CreateTypes } from "canvas-confetti";
import { isHomeEDApp, SURVEY_TYPE } from '@src/constants';
import { Dropdown } from 'antd';
import type { MenuProps } from 'antd';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useToast, useExitTicketLocalStorage, useMarkLessonComplete } from '@src/hooks';
import { ProgressAfterConfetti } from './ProgressAfterConfetti';
import { FeedbackForm } from '@src/types';
import { useStandaloneContent } from '@src/hooks/useStandaloneContent';
import AdditionalModal from '../../additional-modal/AdditionalModal';
import AutoCompleteModal from '@src/components/program-details/complete-modal/AutoCompleteModal';
import { resetGoogleTranslateWidget } from '@src/utils/helpers';
import { logger } from '../../../../utils/logger';
import ForceCompleteModal from '@src/components/program-details/complete-modal/ForceCompleteModal';

type Props = {
  children: React.ReactNode;
  fullScreen: boolean;
  leftButton?: React.ReactNode;
  rightButton?: React.ReactNode;
  totalPages?: number;
  pageNumber?: number;
  className?: string;
  hideNextButton?: boolean;
  isPreview?: boolean;
  exitTicket?: boolean;
  goBack?: () => void;
  formData?: string | null;
  videoEnd?: boolean;
  handlePauseVideo?: () => void;
};

function Actions(props: Props) {
  const {children, rightButton, leftButton, totalPages, pageNumber, className = '', hideNextButton, isPreview = false, exitTicket=false, goBack, videoEnd, handlePauseVideo, formData, fullScreen} = props;
  const {hasNextContent, selectNext, selectPrev, selectExitTicket, hasAdditionalContent, hasPrevContent} = useNextContent();
  const { section, startedAlternateLesson, lesson, content, lastContent, exitTickets, setShowExitModal, showExitTicket, isPreProgramQuiz, isNewLessonLayout, programName } = useStandaloneContent();

  const { successToast } = useToast();
  const { getFormId, removeFormId } = useExitTicketLocalStorage();

  const canvasRef = useRef<HTMLCanvasElement>(null), fireRef = useRef<CreateTypes | null>(null);

  const [completeModal, setCompleteModal] = useState(false);
  const [showReturningUnit, setShowReturningUnit] = useState(false);

  const [showRememberNotify, setShowRememberNotify] = useState(false);
  const [showHereModal, setShowHereModal] = useState(false);

  const [hideCanvas, setHideCanvas] = useState(true);
  // const [isComplete, setIsComplete] = useState(false);
  const [lastPage, setLastPage] = useState(0);

  const [timeOnLastModule, setTimeOnLastModule] = useState(0);
  const [showAutoCompleteModal, setShowAutoCompleteModal] = useState(false);

  const isPhone = useMemo(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    const regexs = [/(Android)(.+)(Mobile)/i, /BlackBerry/i, /iPhone|iPod/i, /Opera Mini/i, /IEMobile/i]
    return regexs.some((b) => userAgent.match(b))
  }, [])

  const handleGoback = useCallback(() => {
    resetGoogleTranslateWidget();
    goBack?.();
  }, [goBack])

  const onMarkLessonCompleted = useCallback(() => {
    setCompleteModal(false);
    setShowReturningUnit(false);
  }, []);

  const { sllMarkLessonComplete, loading: isMarkLessonCompleteLoading } = useMarkLessonComplete(onMarkLessonCompleted, handleGoback, undefined);

  const exitTicketActive = useMemo(() => {
    let tickets = exitTickets
    return tickets.length > 0 ? tickets[0] : null
  }, [exitTickets])

  const jsonFormData = useMemo(() => {
    if (!formData) return null;
    try {
      return JSON.parse(formData) as FeedbackForm;
    } catch(e) {
      logger.info('parse error-', e, formData);
      return null
    }
  }, [formData]);

  const formTypeExitTicket = useMemo(() => (Number(jsonFormData?.surveyType) === SURVEY_TYPE.EXIT_TICKET ? true : false), [jsonFormData]);
  const formTypePreProgram = useMemo(() => (Number(jsonFormData?.surveyType) === SURVEY_TYPE.NA_PRE_PROGRAM_QUIZ ? true : false), [jsonFormData]);

  const lastmodule = useMemo(() => {
    const modules = [...(lesson?.presentation || [])];
    if (modules.length > 2) {
      const index = modules.findIndex(m => m?.id === content?.id);
      if (index === modules.length - 2 && modules.at(modules.length-1)?.lastInLesson) {
        return true;
      }
    }
    return false;
  }, [content, lesson]);
  const width = useMemo(() => window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth, []);
  const height = useMemo(() => window.innerHeight, []);

  const handleCompleteLesson = useCallback(async () => {
    if (lesson) {
      await sllMarkLessonComplete(lesson, programName);
      resetGoogleTranslateWidget();
      if (startedAlternateLesson) {
       handleGoback()
      }
    }
  }, [lesson, startedAlternateLesson, programName, sllMarkLessonComplete, handleGoback]);

  useEffect(() => {
    if (canvasRef.current) {
      fireRef.current = create(canvasRef.current, {} as any);
    }
  }, []);
  const fire = useCallback(() => {
    if (fireRef.current) {
      fireRef.current({
        particleCount: 1200,
        shapes: ['circle', 'square', 'circle',],
        startVelocity: 50,
        spread: 360,
        origin: {
          x: Math.random(),
          y: Math.random() - 0.1
        }
      });
    }
  }, []);

  const handleCongrates = useCallback(() => {
    setHideCanvas(false);
    if (!isPreview) {
      fire();
      setTimeout(() => {
        fire();
        setTimeout(() => {
          fire();
          setTimeout(() => {
            fire();
          }, 500)
        }, 500)
      }, 500)
    }
    setTimeout(() =>{
      setHideCanvas(true);
    }, 10000);
    setTimeout(() => {
      setTimeout(() => {
        setShowRememberNotify(true);
        setTimeout(() => {
          // setShowStudentNotify(true);
          setTimeout(() => {
            setShowRememberNotify(false);
            // setTimeout(() => {
            //   setShowStudentNotify(false);
            // }, 5000)
          }, 10000)
        }, 5000)
      }, 5000);
    }, 1000)

  }, [isPreview, fire])

  const [cancelFeedbackForm] = useCancelFeedbackFormMutation({
    onError(e) {
      logger.debug(`[e]`, e);
    },
    onCompleted(data) {
      if (data.cancelFeedbackForm) {
        removeFormId(lesson?.id)
      }
    }
  })
  const isLastPage = useMemo(() => {
    if (pageNumber) {
      setLastPage(pageNumber);
      return (((totalPages === pageNumber) && (lastPage === (totalPages - 1))) || ((totalPages === pageNumber && totalPages === 1)))
    }
    return false
  }, [totalPages, pageNumber, lastPage])

  useEffect(() => {
    if (pageNumber) {
      if (lastContent && content?.lastInLesson && !hasNextContent && !isPreview && isLastPage) {
        setTimeout(() => {
          handleCongrates();
        }, 500)
      }
    } else {
      if (lastContent && content?.lastInLesson && !hasNextContent && !isPreview) {
        setTimeout(() => {
          handleCongrates();
        }, 500)
      }

      if (content?.additionalAfter && hasNextContent && !isPreview) {
        if (content.type === ContentType.VIDEO && videoEnd) {
          setShowHereModal(true)
        }
      }
    }
  }, [content, handleCongrates, pageNumber, hasNextContent, isLastPage, isPreview, lastContent, videoEnd])

  const handleGoBack = useCallback(() => {
    setShowHereModal(false)
  }, [])

  const handleAdditional = useCallback(() => {
    setShowHereModal(false);
    selectNext();
  }, [selectNext])

  const gotoExitTicket = useCallback(() => {
    setShowHereModal(false);
    selectExitTicket();
  }, [selectExitTicket])

  const handleComplete = useCallback(() => {
    if (startedAlternateLesson && section?.id && !(/*isComplete ||*/ isPreview)) {
      setTimeout(() => {
        setCompleteModal(true);
        handleGoback();
      }, 500);
      return
    }
    if ((/*isComplete ||*/ (isPreview && !isNewLessonLayout) || !(content?.lastInLesson || !hasNextContent)) && goBack) { // check lastmodule
      goBack();
    } else {
      if (isPreProgramQuiz) {
        setCompleteModal(true);
      } else {
        setCompleteModal(true);
      }
    }
  },[startedAlternateLesson, content, isPreview, goBack, hasNextContent, section?.id, isPreProgramQuiz, isNewLessonLayout, handleGoback]);

  // Timer effect for last module
  useEffect(() => {
    let intervalId: NodeJS.Timeout;

    if (lastmodule && !isPreview && !showAutoCompleteModal) {
      // Start timer when user is on last module
      intervalId = setInterval(() => {
        setTimeOnLastModule(prev => {
          const newTime = prev + 1;
          // Show modal after 10 minutes (600 seconds)
          if (newTime >= 600) {

            setShowAutoCompleteModal(true);
            clearInterval(intervalId);
          }
          
          return newTime;
        });
      }, 1000); // Update every second
    } else {
      // Reset timer when not on last module or modal is shown
      setTimeOnLastModule(0);
    }

    // Cleanup interval on unmount or when dependencies change
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [lastmodule, isPreview, showAutoCompleteModal]);

  // Reset timer when user navigates away from last module
  useEffect(() => {
    if (!lastmodule) {
      setTimeOnLastModule(0);
      setShowAutoCompleteModal(false);
    }
  }, [lastmodule]);

  // Handle AutoCompleteModal close
  const handleAutoCompleteModalClose = useCallback(() => {
    setShowAutoCompleteModal(false);
    setTimeOnLastModule(0); // Reset timer when modal is closed
  }, []);

  // Handle AutoCompleteModal complete action
  const handleAutoComplete = useCallback(() => {
    setShowAutoCompleteModal(false);
    handleCompleteLesson();
  }, [handleCompleteLesson]);

  const handleGenerateExitLink = useCallback(() => {
    setShowExitModal(true)
  }, [setShowExitModal]);

  useEffect(() => {
    const handleTabClose = (event: { preventDefault: () => void; returnValue: string; }) => {
      event.preventDefault();
      if (!content?.lastInLesson){
        return '';
      }
      resetGoogleTranslateWidget();
      return (event.returnValue = 'Are you sure you want to exit?');
    };

    window.addEventListener('beforeunload', handleTabClose);
    return () => {
      window.removeEventListener('beforeunload', handleTabClose);
    };
  }, [content?.lastInLesson]);

  const handlePrev = useCallback(() => {
    selectPrev()
  }, [selectPrev]);

  const onNext = useCallback(() => {
    if (content?.additionalAfter && hasNextContent && !isPreview && hasAdditionalContent) {
      if (handlePauseVideo) {
        handlePauseVideo();
      }
      setShowHereModal(true)
      return
    }
    // ToDo: temporarily comment out pause modal
    // if (nextContent && nextContent.pauseHere) {
    //   setPauseModal(true);
    // } else {
      // if (lastmodule) {
      //   handleComplete();
      // } else {
    selectNext();
      // }
    // }
  }, [content, hasNextContent, isPreview, hasAdditionalContent, selectNext, handlePauseVideo]);

  const survey = useMemo(() => {  // Exit Ticket
    if (content?.type === ContentType.FORM && showExitTicket) {
      return true
    } else {
      return false
    }
  }, [content, showExitTicket])

  useEffect(() => {
    if (exitTicketActive?.expiryMinutes === 0 && exitTicketActive?.status) {
      const formId = getFormId(lesson?.id)
      if (formId) {
        cancelFeedbackForm({
          variables: {
            input: { id: formId }
          }
        })
      }
    }
  }, [lesson, exitTicketActive, cancelFeedbackForm, getFormId]);

  const generateExitTicket = (e: any) => {
    if (e.domEvent) {
      e.domEvent.stopPropagation()
    } else {
      e.stopPropagation()
    }
    setShowExitModal(true)
  }

  const cancelExitTicket = (e: any) => {
    if (e.domEvent) {
      e.domEvent.stopPropagation()
    } else {
      e.stopPropagation()
    }
    const formId = getFormId(lesson?.id)
    if (formId) {
      cancelFeedbackForm({
        variables: {
          input: { id: formId }
        }
      })
    }
  }

  const copyToClipboard = (e: any) => {
    if (e.domEvent) {
      e.domEvent.stopPropagation()
    } else {
      e.stopPropagation()
    }
    successToast('Link Copied Successfully!');
  }

  const ticketActiveMenu: MenuProps['items'] = [
    {
      key: '1',
      label: (
        <div className={styles.activeInfoMenu} onClick={e => e.stopPropagation()}>
          <OutlineIcon width={21} className={styles.outlineIcon} />
          <div className={styles.activeInfo}>
            <span>
              <strong>{Math.round((exitTicketActive?.expiryMinutes ?? 0)/60)}</strong> Minutes Left
            </span>
            <span>
              <strong>{exitTicketActive?.exitTicketCount}</strong> Responses Max
            </span>
          </div>
        </div>
      ),
    },
    {
      key: '2',
      label: (
        <div className={styles.dropDownMenuitem}>
          Cancel
        </div>
      ),
      onClick: (e) => cancelExitTicket(e)
    },
    {
      key: '3',
      label: (
        <CopyToClipboard text={exitTicketActive?.copyLink ?? ''} >
          <div className={styles.dropDownMenuitem}>
            Copy Link
          </div>
        </CopyToClipboard>
      ),
      onClick: (e) => copyToClipboard(e)
    },
    {
      key: '4',
      label: (
        <div className={styles.dropDownMenuitem}>
          Regenerate
        </div>
      ),
      onClick: (e) => generateExitTicket(e)
    }
  ]

  return (
    <>
      <div className={`${styles.content} ${className}`} style={{backgroundColor: isPhone ? '#535353' : '', paddingBottom: (isPreview && !isHomeEDApp && !isNewLessonLayout) ? 40 : 0}}>
      <div className={styles.notifyView}>
        {survey ? <div className={styles.notifySubView2} style={{display: showRememberNotify ? "grid" : "none"}}>
          <InfoCircleIcon className={styles.infoCircle} />
          <div className={styles.notifyDetail}>
            <p>Please distribute the Exit Ticket Link to students</p>
          </div>
        </div> : null}
        {/* <div className={styles.notifySubView3} style={{display: showStudentNotify ? "grid" : "none"}}>
          <InfoCircleIcon className={styles.infoCircle} />
          <div className={styles.notifyDetail}>
            <p style={{marginBottom: "20px"}}>Each student will now complete a knowledge-check of the Topic.</p>
            <p>Responses will be emailed to the teacher in 60 minutes.</p>
          </div>
        </div>   */}
      </div>
      {showReturningUnit ? <div className={styles.returnView}>
        <div className={styles.closeButton} onClick={handleGoback}>
          <CloseIcon className={styles.closeIcon}/>
        </div>
        <div  className={styles.progressView}>
          <ProgressAfterConfetti goBack={handleGoback} />
        </div>
      </div> : null}

        {children}
        <div className={styles.confettiView} style={{display: hideCanvas ? 'none' : 'block'}}>
          <canvas ref={canvasRef} width={width} height={height} />
        </div>
      </div>
      <div className={`${styles.actions} ${(isPreview || survey) ? (!fullScreen || survey) ? styles.whiteBar : styles.blackBar : styles.blackBar}`}>
        {leftButton ? <div className={styles.prevAction}>{leftButton}</div> : <>
          {hasPrevContent ? <div className={styles.prevAction}>
            <Button size={'extraSmall'} onClick={handlePrev} outline={true} label={'PREVIOUS'}
                    className={`${(isPreview || survey || isPhone) ? styles.fullScreenWhitePrevious : styles.fullScreenPrevious}`}/>
          </div> : <div/>}
        </>}
        {Boolean(totalPages) && Boolean(pageNumber) && <div className={styles.pages}>
        <span className={styles.currentPage}>{pageNumber}</span>/{totalPages}
        </div>}
        {rightButton ? <div className={styles.endAction}>{rightButton}</div> : <>
          {
            hasNextContent && !hideNextButton ? (
              <div className={styles.nextActions}>
                {exitTicket && exitTicketActive?.formData && !exitTicketActive.status ?
                <Button size={'extraSmall'} onClick={onNext} color={'white'} outline={true} label={'SKIP EXIT TICKET'} className={styles.skipExitTicketaction}/> :
                <Button size={'extraSmall'} onClick={onNext} color={'white'} label={lastmodule ? (startedAlternateLesson ? `END ${section?.name || ''}` : 'END LESSON') : 'CONTINUE'} className={styles.action}/>}
              </div>
            ) : (!hasNextContent && (!isPreview || isNewLessonLayout))
                  ? (
                    <div className={styles.endAction}>
                      <Button size={'extraSmall'} onClick={handleComplete} color={'white'} label={startedAlternateLesson ? `END ${section?.name || ''}` : 'END LESSON'}/>
                    </div>)
                  : (!isHomeEDApp && exitTicket)
                    ?
                      isPreview ? null :
                    (
                      <div className={styles.endAction}>
                        {!exitTicketActive?.status
                          ? (<Button size={'small'} onClick={handleGenerateExitLink} color={'white'} leftIcon={<TicketIcon />} label={formTypePreProgram ? 'Create Quiz Link' : formTypeExitTicket ? 'Create Exit Ticket Link' : 'Generate Survey Link'}/>)
                          : (
                            <Dropdown menu={{ items: ticketActiveMenu }} trigger={['click']} placement="bottomRight" >
                              <Button size='small' className={styles.exitTicketActiveButton}
                                leftIcon={<TicketIcon />} label={formTypePreProgram ? 'Pre-Program Active' : formTypeExitTicket ? 'Exit Ticket Active' : 'Research Survey Active'} rightIcon={<WarningIcon width={20} height={21} className={styles.warningIcon}/>}
                              />
                            </Dropdown>
                            )
                        }
                      </div>)
                    : null
            }
          </>
        }
      </div>
      {/* {pauseModal && <PauseModal open={pauseModal} onClose={handlePause} onContinue={handleContinue}/>}*/}
      {completeModal && <AutoCompleteModal open={completeModal} loading={isMarkLessonCompleteLoading} onClose={() => setCompleteModal(false)} onComplete={handleCompleteLesson} />}
      {showHereModal && <AdditionalModal open={showHereModal} onClose={handleGoBack} onAdditionalExperience={handleAdditional} onExitTicket={gotoExitTicket} />}
      {showAutoCompleteModal && (
        <ForceCompleteModal 
          open={showAutoCompleteModal} 
          loading={isMarkLessonCompleteLoading} 
          onClose={handleAutoCompleteModalClose} 
          onComplete={handleAutoComplete} 
        />
      )}
    </>
  );
}

export default Actions;
